export const VIBRATION_PROFILE_DESCRIPTIONS = [
  "Transient - Robust",
  "Continuous - Robust",
  "Transient - Sensitive",
  "Continuous - Sensitive",
] as const;

export const DEFAULT_VIBRATION_PROFILE_DESCRIPTION =
  VIBRATION_PROFILE_DESCRIPTIONS[0];

export function isVibrationProfileDescription(description?: string): boolean {
  return VIBRATION_PROFILE_DESCRIPTIONS.includes(description as any);
}

export function sortVibrationProfiles<
  T extends { description: string; profile_type?: string },
>(profiles?: T[]): T[] {
  const list = (profiles ?? []).filter(
    (profile) =>
      profile.profile_type === "vibration" &&
      isVibrationProfileDescription(profile.description),
  );

  return VIBRATION_PROFILE_DESCRIPTIONS.flatMap((description) =>
    list.filter((profile) => profile.description === description),
  );
}
